import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "内容导航",
    links: [
      { to: "/category", label: "电影全片库" },
      { to: "/news", label: "影视资讯" },
      { to: "/reviews", label: "影评专区" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { to: "/about", label: "关于我们" },
      { to: "/about", label: "联系我们" },
      { to: "/", label: "返回首页" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-500 text-foreground-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950">
                <span className="absolute left-1/2 top-1/2 flex h-5 w-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-[3px] border-background-50 bg-background-50">
                  <span className="h-1.5 w-1.5 rounded-full bg-foreground-950"></span>
                </span>
              </span>
              <span className="font-heading text-lg font-bold">小黄人电影</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-900/80">
              一个专注于小黄人系列电影及相关动画作品的内容站。这里有最新的影视资讯、详尽的剧情介绍和真诚的影评，陪影迷一起，把快乐看个够。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-950/10 text-foreground-950"
                >
                  <i className={`${icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-label text-sm font-bold uppercase tracking-wide text-foreground-950">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-900/80 transition hover:text-foreground-950 hover:underline"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-foreground-950/15 pt-6 text-xs text-foreground-900/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 小黄人电影 · 本站为动画影视内容演示站点，所有内容仅供参考。</p>
          <p>内容源于公开资料整理 · 与影片版权方无隶属关系</p>
        </div>
      </div>
    </footer>
  );
}